module.exports = __webpack_public_path__ + "img/add-a-pet.548936c4.svg";